export const BASE_URL = "https://miliki.imperotechne.com/api/web"; // `https://testenv.ciphernet.net/milikiapp/api/web`;
